import React from "react";
import { Link } from "react-router-dom";
import styles from "./Sidebar.module.css";

const Sidebar = () => {
  return (
    <div className={styles.sidebar}>
      <h2 className={styles.title}>관리자페이지</h2>
      <ul className={styles.menu}>
        <li className={styles.menuItem}>
          <Link to="/admin-v2/product">상품 관리</Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
